exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opacity0[data-v-5ebe7361]{opacity:0}.wrapper-name[data-v-5ebe7361]{display:flex;white-space:nowrap}.wrapper-name .name[data-v-5ebe7361]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
